import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { LocaleService } from '@app/system/services/locale.service';
import { SkillsSelectionModel } from '../utilities/models/skills-selection-model';
import { WeightageModel } from '../utilities/models/weightage-model';
import { BuilderService } from '../utilities/services/builder.service';
import { FunctionsService } from '../utilities/services/functions.service';




@Component({
	selector: 'app-skills-selection',
	templateUrl: './skills-selection.component.html',
	styleUrls: ['./skills-selection.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => SkillsSelectionComponent),
		multi: true
	}]
})
export class SkillsSelectionComponent implements OnInit, ControlValueAccessor {

	@Input() field: SkillsSelectionModel;
	@Input() control: UntypedFormControl;

	@Output() helpLineEmit = new EventEmitter();

	showSkill = false;
	selectedIndex;
	previousIndex;
	skillValue = [];
	currentCompetencyName = '';

	constructor(
		public controlFunctions: FunctionsService,
		public locale: LocaleService,
		private builderService: BuilderService,
	) {
	}

	ngOnInit(): void {

	}
	ngOnChanges(changes) {
		if (changes.field && changes.field.currentValue) {
			if (this.field.value && this.field.value.length && this.field.options) {
				const options = this.field.options.data;
				for (let i = 0; i < options.length; i++) {
					let match = false;
					if (options[i].childData && options[i].childData.data.length) {
						for (let j = 0; j < options[i].childData.data.length; j++) {
							const data = this.field.value.find(items => items.key === options[i].childData.data[j].key);
							if (data) {
								options[i].childData.data[j].skillLevel = data.skillLevel;
								match = true;
								this.skillValue.push(
									{
										skillLevel: data.skillLevel,
										key: data.key,
										value: data.value,
										index: i,
										childIndex: j
									}
								);
								options[i].childData.data[j].selected = true;
							}
						}
					}
					if (match) {
						options[i].selected = true;
						break;
					}
				}
			}
		}
	}

	showSkills(data, index) {
		if (navigator.onLine && !this.field.isReadonly) {
			this.currentCompetencyName = data.value;
			this.selectedIndex = index;
			this.showSkill = true;
			data.selected = false;

			if (this.field.additionalMetaData.selectionType === 'weightage') {

				data.childData.data.forEach((skillData, childIndex) => {
					const weightage: WeightageModel = {
						fieldCaption: skillData.value,
						fieldColumn: skillData.value,
						additionalMetaData: {
							maxWeightage: this.field.additionalMetaData.maxWeightage,
							minWeightage: this.field.additionalMetaData.minWeightage,
							defaultWeightage: this.field.additionalMetaData.defaultWeightage,
							showHelp: this.field.additionalMetaData.showHelp
						},
						fieldType: 'weightage',
						isHidden: false,
						isReadonly: false,
						isRequired: false,
						value: null
					};
					if (skillData.skillLevel) {
						weightage.isReadonly = true;
					}

					for (const skill of this.skillValue) {
						if (skill.index === index && skill.childIndex === childIndex) {
							weightage.value = skill.skillLevel;
							data.selected = true;
						}
					}

					this.builderService.fieldModelBuilder(weightage);
					const control: UntypedFormControl = this.builderService.controlBuilder(weightage);
					skillData.control = control;
					skillData.field = weightage;

					control.valueChanges.subscribe(resp => {
						const skillValue = {
							skillLevel: resp,
							key: skillData.key,
							value: skillData.value,
							index,
							childIndex
						};
						if (resp !== 0 && !isNaN(resp)) {
							this.manageSkill('add', skillValue);
						} else {
							data.selected = false;
							this.manageSkill('remove', skillValue);
						}
					});
				});

			} else if (this.field.additionalMetaData.selectionType === 'standard') {

			}
		}
	}

	selectSkills(data, index) {
		if (navigator.onLine && !this.field.isReadonly) {
			if (this.field.additionalMetaData.selectionType === 'standard') {
				data.selected = (data.selected) ? false : true;
				const type = (data.selected) ? 'add' : 'remove';
				const skillValue = {
					skillLevel: data.skillLevel,
					key: data.key,
					value: data.value,
					index: this.selectedIndex,
					childIndex: index
				};
				this.manageSkill(type, skillValue);

			}
		}
	}

	weightageTriggered(competencyData, skillData) {
		if (navigator.onLine) {
			if (skillData.field.isReadonly) {
				skillData.field.isReadonly = false;
				skillData.field.value = skillData.skillLevel;
				skillData.control.patchValue(skillData.skillLevel, { emitEvent: true });
				skillData.control.enable();
				skillData.field = Object.assign({}, skillData.field);
				skillData.skillLevel = null;
				competencyData.selected = true;
			}
		}
	}

	manageSkill(type: string, data: any) {
		if (navigator.onLine) {
			if (this.skillValue.length > 0) {
				let newData = true;
				this.skillValue.forEach((skillData, skillIndex) => {
					if (skillData.index === data.index && skillData.childIndex === data.childIndex) {
						newData = false;
						if (type === 'add') {
							this.skillValue[skillIndex] = data;
						} else if (type === 'remove') {
							this.skillValue.splice(skillIndex, 1);
						}
					}
				});
				if (newData) {
					this.skillValue.push(data);
				} else {
				}
			} else {
				if (type === 'add') {
					this.skillValue.push(data);
				}
			}


			if (this.skillValue.length > 0) {
				const finalValue = [];
				const controlValue = [];
				for (const skill of this.skillValue) {
					if (skill.index === data.index) {
						finalValue.push(skill);
						controlValue.push({
							skillLevel: skill.skillLevel,
							key: skill.key,
							// value: skill.value
						});
						this.field.options.data[skill.index].selected = true;
					} else {
						this.field.options.data[skill.index].selected = false;
					}
				}
				this.skillValue = finalValue;
				if (this.control.errors) {
					this.control.setErrors(null);
				}
				this.control.patchValue(controlValue, { emitEvent: true });
			} else {
				if (this.field.isRequired) {
					this.control.setErrors({ required: true });
				}
				this.control.patchValue(null, { emitEvent: true });
			}
		}
	}

	showCompetencies() {
		if (navigator.onLine && !this.field.isReadonly) {
			if (this.field.additionalMetaData.selectionType === 'standard') {
				const selectedSkills = [];
				for (const skill of this.skillValue) {
					if (this.selectedIndex === skill.index) {
						selectedSkills.push(skill)
					}
				}
				if (selectedSkills.length > 0) {
					this.field.options.data[this.selectedIndex].selected = true;
					for (let i = 0; i < this.field.options.data.length; i++) {
						if (i !== this.selectedIndex) {
							for (let j = 0; j < this.field.options.data[i].childData.data.length; j++) {
								this.field.options.data[i].childData.data[j].selected = false;
							}
						}
					}
				} else {
					this.field.options.data[this.selectedIndex].selected = false;
					for (const skill of this.field.options.data[this.selectedIndex].childData.data) {
						skill.selected = false;
					}
				}
			}
			this.showSkill = false;
		}
	}


	writeValue(value: null) { }

	registerOnChange(fn: () => void) { }

	registerOnTouched(fn: () => void) { }

	/**
* @desc Help line field change method
* @param object helpLineEmit - help line json data.
*/
	helpLineData(data) {
		this.helpLineEmit.emit(data);
	}

}
